import React, { useEffect } from 'react';

import Button from '@amzn/meridian/button';
import Column from '@amzn/meridian/column';
import Row from '@amzn/meridian/row';

import { PlanDetail } from 'src/components/PaperPlanDetail/PlanDetail';
import { IPlanProps } from 'src/types/IPaperPlan';

import { getPrefilledWeightsMap } from '../AddWeights/addWeightsUtils';
import './PlanReview.scss';

export const PlanReview: React.FC<IPlanProps> = ({
    onPrevious,
    onCancel,
    onSubmit,
    onSaveDraft,
    planValues,
    planWeights,
    handlePlanWeightsBusinessRulesChange
}: IPlanProps) => {
    // Prepopulate plan weights by applying business rules
    useEffect(() => {
        const preFilledPlanWeights = getPrefilledWeightsMap(planValues);
        handlePlanWeightsBusinessRulesChange(preFilledPlanWeights);
    }, []);

    return (
        <>
            <PlanDetail heading="Review and add" planValues={planValues} planWeights={planWeights} />

            <Column spacingInset="500 none none none">
                <Row alignmentHorizontal="end">
                    <Button type="link" onClick={onCancel} aria-label="Cancel plan">
                        Cancel
                    </Button>
                    <Button type="tertiary" onClick={onPrevious} aria-label="Go to previous step">
                        Previous
                    </Button>
                    <Button type="tertiary" onClick={onSaveDraft} aria-label="Save draft">
                        Save draft
                    </Button>
                    <Button type="primary" onClick={onSubmit} aria-label="Add plan">
                        Add plan
                    </Button>
                </Row>
            </Column>
        </>
    );
};
